import type { ReactNode } from "react";
import { useTranslations } from "next-intl";

import { BlockBreadcrumbsV2 } from "@/app/_blocks/BlockBreadcrumbsv2";
import type { BreadcrumbLink } from "./types";

function DisclaimerLink({ href, children }: { href: string; children: ReactNode }) {
  return (
    <a
      href={href}
      target='_blank'
      className='tw-underline tw-underline-offset-2 hover:tw-no-underline'
      rel='noreferrer'
    >
      {children}
    </a>
  );
}

function UsageDisclaimer() {
  const t = useTranslations("ClientKeys.creative_templates");

  return (
    <p className='tw-mt-2 tw-px-4 tw-text-[11px] tw-leading-normal tw-text-black/50'>
      {t.rich("usage_disclaimer", {
        termsLink: chunks => <DisclaimerLink href='/terms-of-use'>{chunks}</DisclaimerLink>,
        privacyLink: chunks => <DisclaimerLink href='/privacy-policy'>{chunks}</DisclaimerLink>,
      })}
    </p>
  );
}

const CONTAINER_CLASSNAME = "tw-grid tw-grid-cols-1 tw-items-start tw-gap-10 lg:tw-grid-cols-[2fr_2fr]";
export function HeroLayout({
  breadcrumbs,
  heroTitle,
  heroDescription,
  actions,
  media,
}: {
  breadcrumbs: BreadcrumbLink[];
  heroTitle: string;
  heroDescription: string;
  actions?: ReactNode;
  media: ReactNode;
}) {
  return (
    <>
      <div className={CONTAINER_CLASSNAME}>
        <div className='tw-flex tw-h-full tw-min-w-0 tw-flex-col tw-justify-between tw-gap-6'>
          <div className='tw-flex tw-flex-col tw-gap-6'>
            <BlockBreadcrumbsV2 links={breadcrumbs} size='small' />
            <h1 className='tw-type-4xl tw-mt-1'>{heroTitle}</h1>
            {heroDescription && <p className='tw-type-base tw-mr-24'>{heroDescription}</p>}
          </div>
          {actions}
        </div>
        <div className='tw-relative tw-aspect-square tw-w-full tw-max-h-[60vh] tw-overflow-hidden tw-rounded-3xl'>
          {media}
        </div>
      </div>
      <div className={CONTAINER_CLASSNAME}>
        <UsageDisclaimer />
        <div />
      </div>
    </>
  );
}
